import { render, staticRenderFns } from "./IntergralCenter.vue?vue&type=template&id=aeeb32b4&scoped=true"
import script from "./IntergralCenter.vue?vue&type=script&lang=js"
export * from "./IntergralCenter.vue?vue&type=script&lang=js"
import style0 from "./IntergralCenter.vue?vue&type=style&index=0&id=aeeb32b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeeb32b4",
  null
  
)

export default component.exports